import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'

import { addToast } from 'components/Toast/Toast'
import { sendStoryMessage } from 'services/endpoints/message'
import { type StoryMessage } from 'types/api/message'

export const useSendStoryMessage = (id: string) => {
    const { t } = useTranslation()
    const mutation = useMutation({
        mutationFn: async (payload: StoryMessage) =>
            await sendStoryMessage(payload, id),
        onSuccess: () => {
            // addToast('success', t('theMessageWasSent'))
        },
        onError: () => {
            addToast('error', t('error:errorSomethingWentWrong'))
        }
    })
    return mutation
}
